module.exports = __webpack_public_path__ + "img/productPrice-mobile.e75c15b2.png";